<template>
    <div>
        <section class="section-hero section-shaped my-0">
            <div class="shape shape-style-1 shape-primary">
                <div class="hero-hover"></div>
            </div>
            <div class="container shape-container d-flex align-items-center">
                <div class="col px-0">
                    <div class="row justify-content-center align-items-center">
                        <div class="col-lg-9 text-center pt-lg hero-text">

                            <p class="text-white mt-0 subtitle font-weight-bold">Machine Learning Systems Seminar Series</p>
                            <!-- <p class="lead text-white mt-1 mb-2 subsubtitle">Introduction to Embodied Intelligence</p> -->
                            <!-- <p class="lead text-white mt-1 mb-2 subsubtitle">课程代码:AIB310002</p> -->
                            <p class="lead text-white mt-1 mb-2 subsubtitle">Talks Time : Thursday 10:30 - 11:30</p>
                            
                            <!-- <p class="lead text-white mt-1 mb-2 subsubtitle" style="text-decoration: underline; text-decoration-thickness: 2px; text-underline-offset: 2px;">本课程Project由豆包AI助手＆豆包大模型支持</p> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section section-lg">

            <div class="container">

                <div>
                    <h4 class="font-weight-bold">
                                Introduction
                            </h4>
                    <p class="custom-title">
                        <strong>In collaboration with the Machine Learning Systems (ML Sys) course, we are organizing a Machine Learning Systems Seminar Series. </strong>
                    </p>
                    <p class="custom-title">The goal of this seminar series is to help students shift from an academic model-centric mindset to one that embraces real-world system development and deployment. To support this transformation, we invite industry experts to deliver talks on topics aligned with the course content, including (but not limited to): ML compilers and optimizations, parallel training, inference systems, deployment on mobile and edge devices, hardware accelerators, and open-source community practices. </p>
                    <p class="custom-title">
                        Talks are held every Thursday from 10:30 AM to 11:30 AM and will be livestreamed weekly on Feishu.
                    </p>
                    <p class="custom-title">
                        If you're interested, feel free to reach out to us or subscribe to our mailing list!
                    </p>

                    <div class="row">
                        <div class="col-sm-12 py-3 px-0">
                            <!--标题-->
                            <h4 class="font-weight-bold">
                                Talks Schedule
                            </h4>
                            <p></p>
                            <p></p>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Topic</th>
                                        <th>Speaker</th>
                                        <th>Institution</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                        
                                            
                                                <span>Apr.3</span>
                                                
                                            
                                        </td>
                                        <td>
                                            
                        
                                                <span>Machine learning compilation </span>
                                                <a href="/memx-website/sys_ppt/seminar/Abstractions for ML Compiler - 20250403.pdf"
                                                target="_blank">
                                                <span>[课件下载]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                                </a>
                                                <a href="https://www.alipan.com/s/x7Myu3s8P4k"
                                                target="_blank">
                                                <span>[录像回放]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="录像" width = 16px height = 16px>
                                                </a>
                                        </td>
                                        <td>
                                            冯思远
                                        </td>
                                        <!-- <td style="text-align: left;">
                                            <a href="/memx-website/ei_ppt/week1/representation.pdf" target="_blank">
                                                <span>1.Brooks R A. Intelligence without representation[J]. Artificial
                                                    intelligence, 1991, 47(1-3): 139-159.</span>
                                                <img src="/memx-website/ei_photos/download.jpg" alt="下载" width=16px
                                                    height=16px>
                                            </a><br>
                                            <a href="/memx-website/ei_ppt/week1/Varela_Thompson_Rosch_The_Embodied_Mind_Cognitive_Science_and_Human_Experience_1991%20copy.pdf"
                                                target="_blank">
                                                <span>2.Varela F J, Thompson E, Rosch E. The embodied mind, revised
                                                    edition: Cognitive science and human experience[M]. MIT press,
                                                    2017.</span>
                                                <img src="/memx-website/ei_photos/download.jpg" alt="下载" width=16px
                                                    height=16px>
                                            </a><br>
                                            <a href="https://plato.stanford.edu/archIves/sum2020/entries/embodied-cognition/"
                                                target="_blank">
                                                <span>3.Embodied Cognition[EB/OL].[2024-09-09].
                                                    https://plato.stanford.edu/archIves/sum2020/entries/embodied-cognition/.</span>
                                                <img src="/memx-website/ei_photos/download.jpg" alt="下载" width=16px
                                                    height=16px>
                                            </a>
                                        </td> -->
                                        <td>上海交通大学</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <!-- 下载图标以及链接 -->
                                            <span>Apr.10</span>

                                        </td>
                                        <td>
                                            
                                            Voice agent 
                                            <a href="https://www.alipan.com/s/Fny7nk2DTBS"
                                                target="_blank">
                                                <span>[录像回放]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="录像" width = 16px height = 16px>
                                                </a>
                                        </td>
                                        <td>
                                            吕睿韬 
                                        </td>
                                        
                                        <td>喜马拉雅</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span>Apr.17</span>

                                        </td>
                                        <td>
                                            Corpus Data Construction from the Perspective of Large Model Pre-training 
                                            <a href="/memx-website/sys_ppt/seminar/Corpus Data Construction from the perspective of Large Model pre-training.pdf"
                                                target="_blank">
                                                <span>[课件下载]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                                </a>
                                                <a href="https://www.alipan.com/s/vG5kXm6UHqG"
                                                target="_blank">
                                                <span>[录像回放]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="录像" width = 16px height = 16px>
                                                </a>
                                            
                                        </td>

                                        <td>
                                            张路生
                                        </td>
                                        <td>Bilibili</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <span>Apr.24</span>

                                        </td>
                                        <td>
                                            LLM Inference Infra with AMD platform
                                             <a href="https://www.alipan.com/s/LCYtr3jNjLS"
                                                target="_blank">
                                                <span>[录像回放]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="录像" width = 16px height = 16px>
                                                </a>
                                        </td>

                                        <td>
                                            王翼
                                        </td>
                                        <td>AMD</td>
                                    </tr>
                                    <tr>
                                        <td> <span>May.8</span></td>
                                        <td>
                                            Efficient inference for long-context language models
                                            <a href="/memx-website/sys_ppt/seminar/2025-05-08-Chuangzhi-talk.pdf"
                                                target="_blank">
                                                <span>[课件下载]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                                </a>
                                                <a href="https://www.alipan.com/s/tCgde12JNC7"
                                                target="_blank">
                                                <span>[录像回放]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                                </a>
                                        </td>
                                        

                                        <td>
                                            杨玉庆
                                        </td>
                                        <td>微软亚洲研究院</td>
                                    </tr>
                                    <tr>
                                        <td>May.15</td>
                                        <td>
                                            模型原生操作系统：机遇、挑战与展望
                                             <a href="https://www.alipan.com/s/D3vB8UFPzV8"
                                                target="_blank">
                                                <span>[录像回放]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                                </a>
                                        </td>

                                        <td>
                                           陈海波
                                        </td>
                                        <td>华为</td>
                                    </tr>
                                    <tr>
                                        <td> <span>May.22</span></td>
                                        <td>
                                            大模型应用 - 动画视频智能创作
                                            <a href="/memx-website/sys_ppt/seminar/anisora_offical.pdf"
                                                target="_blank">
                                                <span>[课件下载]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                                </a>
                                                <a href="https://www.alipan.com/s/97VErY7916y"
                                                target="_blank">
                                                <span>[录像回放]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="录像" width = 16px height = 16px>
                                                </a>
                                        </td>

                                        <td>
                                            蒋宇东
                                        </td>
                                        <td>Bilibili</td>
                                    </tr>
                                    <tr>
                                        <td> <span>May.29</span></td>
                                        <td>
                                            Why open source matters
                                            <a href="https://docs.google.com/presentation/d/1PxQN5UH2fEbaTcr1vbIdZPGbtIXu2rM2HO0x13s9uxk/edit?slide=id.p#slide=id.p"
                                                target="_blank">
                                                <span>[课件下载]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                                </a>
                                                <a href="https://www.alipan.com/s/UYgKmXvC4Rf
"
                                                target="_blank">
                                                <span>[录像回放]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="录像" width = 16px height = 16px>
                                                </a>
                                        </td>

                                        <td>王铁震</td>
                                        <td>Hugging face</td>
                                    </tr>
                                    <tr>
                                        <td> <span>Jun.5</span></td>
                                        <td>
                                            面向人工智能的稀疏计算软硬件协同设计方法
                                            <a href="/memx-website/sys_ppt/seminar/人工智能中的稀疏计算方法-戴国浩.pptx"
                                                target="_blank">
                                                <span>[课件下载]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="下载" width = 16px height = 16px> 
                                                </a>
                                                <a href="https://www.alipan.com/s/ATXv9XMDBJP"
                                                target="_blank">
                                                <span>[录像回放]</span>
                                                <img src="/memx-website/sys_photos/download.jpg" alt="录像" width = 16px height = 16px>
                                                </a>
                                        </td>

                                        <td>戴国浩</td>
                                        <td>上海交通大学</td>
                                    </tr>

                                    
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 py-3 px-0">
                            <!--标题-->
                            <h4 class="font-weight-bold">
                                Organizers
                            </h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Li_Shang.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <p class="custom-title">
                                Dr. Li Shang is a Professor at the Computation and Artificial Intelligence Innovative College, Fudan University. He received his Ph.D. degree from Princeton University. He was the Deputy Director and Chief Architect of Intel Labs China, and an Associate Professor of CU Boulder (tenured). His research interests include computer systems, machine learning, VLSI & EDA, with over 180 publications, multiple best paper awards and nominations, and over 9000 citations. He was a recipient of NSF Career Award. He co-founded multiple startups, driving these companies from founding to profitability. At this moment, he is coaching a group of students to initiate a startup on always-on intelligence.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        
                    </div>
                    <div class="row">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Jinlong_Hou.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <p class="custom-title">
                                Jinlong Hou is the Technical Director of the Digital Infrastructure Department at the Institute of Intelligent Innovation. His primary research interests include computer architecture and machine learning systems. He has previously served as the AI platform leader at several renowned internet companies, including Intel, Ant Group, Tencent, Pinduoduo, and Bilibili. Dr. Hou has extensive experience in GPU and domestic AI chip development and is a Huawei Ascend MVP.
                            </p>
                        </div>
                    </div>
                    <div class="row">
                    <div class="col-sm-12 py-3 px-0">
                            <!--标题-->
                            <h4 class="font-weight-bold">
                            Coordinator
                            </h4>
                    </div>
                    <div class="row">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Ping_Wu.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <p class="custom-title">
                                Ping Wu is a research assistant with the MEMX Team. She holds a master’s degree from the Department of Management Science, School of Management, Fudan University. Her primary responsibilities include student affairs management and research project coordination within the team. She has received several honors, including the Outstanding Graduate of Fudan University and the National Graduate Scholarship.
                            </p>
                        </div>
                    </div>
                    </div>
                    <p></p>
                    <p>
                    </p>
                    <div class="row">
                        <div class="col-sm-12 py-3 px-0">
                            <!--标题-->
                            <h4 class="font-weight-bold">
                                Guest Speaker
                            </h4>
                        </div>
                    </div>
                    <div class="row speaker-block">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Siyuan_Feng.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <p class="custom-title">
                                冯思远,上海交通大学博士五年级学生，毕业后将加入上海创智学院担任全职助理教授，主要研究方向是AI 编译器和 AI Infra。本科毕业自上海交通大学 ACM班，目前担任Apache 开源基金会成员、Apache TVM项目管理委员会成员，主导或联合主导项目TensorIR, Relax, MLC-LLM等AI编译器领域开源工作。
                            </p>
                            <p class="custom-title">
                                Topic：机器学习编译 / machine learning compilation
                            </p>
                        </div>
                    </div>
                    
                    
                    <div class="row speaker-block">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Ruitao_Lv.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <p class="custom-title">
                                吕睿韬，花名秀才，喜马拉雅珠峰AI产品负责人，TGO鲲鹏会上海分会会员。
主导研发国际首个语音文本端到端多模态大模型，国际首创5秒音频zero-shot产品。同时主导研发了喜马拉雅内容与营销AI Agent产品、亲子AI实时语音交互产品和音视频AIGC创作工具产品等，服务喜马拉雅3亿月活用户和1000万创作者。
曾担任AI四小龙依图科技产品研发总监，负责CV和Speech产品，主导规划并设计开发智慧园区、智慧轨交、智慧语音等AI产品。
                            </p>
                            <p class="custom-title">
                                Topic：voice agent应用实践与思考
                            </p>
                        </div>
                    </div>
                    
                    <div class="row speaker-block">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Lusheng_Zhang.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <p class="custom-title">
                                Lusheng Zhang is an algorithm engineer in the AI Platform Department of Bilibili. He graduated from the University of Science and Technology of China in 2018 and has previously worked at Tencent and Pinduoduo. Since 2020, he has been responsible for large-scale pre-training projects at Tencent and has released pre-training models with tens of billions of parameters. Currently, at Bilibili, he is involved in the pre-training and post-training of the Index large model, as well as the construction of terabyte-scale corpus data. His work covers aspects such as deduplication of tens of billions of data, research on data ratio, research on training acceleration mechanisms, research on knowledge-enhanced training, and research on model distillation.
                            </p>
                            <p class="custom-title">
                                Topic：Corpus Data Construction from the Perspective of Large Model Pre-training
                            </p>
                        </div>
                    </div>
                   
                    <div class="row speaker-block">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Yi_Wang.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <p class="custom-title">
                                王翼之前在 Graphcore 担任机器学习专家， 后加入 AMD 担任 AI 架构师 （SMTS 主任工程师）。参与贡献诸多机器学习社区开源软件，主要研究兴趣在LLM训练、推理的软件栈优化，并应用计算机体系结构知识协同设计软硬件解决方案.
                            </p>
                            <p class="custom-title">
                                Topic：LLM Inference Infra with AMD platform
                            </p>
                        </div>
                    </div>
                    
                    <div class="row speaker-block">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Yuqing_Yang.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <p class="custom-title">
                                杨玉庆博士现任微软亚洲研究院（上海）首席研发经理，带领系统组（上海）专注于大模型系统和多模态系统的研究。他的研究兴趣包括大模型的高效计算和智能体系统的顶层设计等。相关研究成果多次发表于 OSDI、SOSP、EuroSys、ATC、CVPR、ICCV、NeurIPS等国际顶级会议。
                            </p>
                            <p class="custom-title">
                               Topic：Efficient inference for long-context language models
                            </p>
                            <!-- <h5>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Abstract: Transformer-based Large Language Models (LLMs) have become increasingly important. However, due to the quadratic time complexity of attention computation, scaling LLMs to longer contexts incurs extremely slow inference latency and high GPU memory consumption for caching key-value (KV) vectors. In this talk, we will introduce the latest advancement of efficient inference for long-context LLMs. To reduce the large prefilling latency, we introduce MInference (Million-tokens Inference), a sparse calculation method designed to accelerate pre-filling of long-sequence processing. Our proposed technique can be directly applied to existing LLMs without any modifications to the pre-training setup or additional fine-tuning. By evaluating on a wide range of downstream tasks, we demonstrate that MInference effectively reduces inference latency by up to 10x for pre-filling on an A100, while maintaining accuracy. Beyond prefilling, we will present RetrievalAttention, a training-free approach to both accelerate attention computation and reduce GPU memory consumption. By leveraging the dynamic sparsity of attention mechanism, RetrievalAttention proposes to use approximate nearest neighbor search (ANNS) indexes for KV vectors in CPU memory and retrieves the most relevant ones with vector search during generation. Besides these two works, we will also discuss a unified perspective on KV-centric LLM inference, and propose future research directions.  
                            </h5> -->
                        </div>
                    </div>
                   
                    <div class="row speaker-block">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Haibo_Chen.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <p class="custom-title">
                                陈海波,上海交通大学特聘教授、并行与分布式系统研究所所长，领域操作系统教育部工程研究中心主任。 国家杰出青年基金获得者、ACM Fellow、IEEE Fellow，曾获陈嘉庚青年科学奖（信息技术科学）、中国青年科技奖、教育部技术发明一等奖（第一完成人）、全国优秀博士学位论文奖、CCF青年科学家奖、上海交通大学校长奖等。目前担任OpenHarmony技术指导委员会创始主席、ACM旗舰杂志《Communications of the ACM》中国首位编委与Special Sections领域共同主席、ACM EuroSys 2025程序委员会共同主席、ACM SIGOPS首位非北美学者主席、《ACM Transactions on Storage》编委。曾任ACM SIGOPS ChinaSys主席、ACM SOSP 2017年大会联席主席、ACM SIGSAC奖励委员会委员、ACM SIGOPS Dennis M. Ritchie Award等奖励委员会委员。研究工作也获得华为卓越贡献个人奖、SOSP/ASPLOS/EuroSys/VEE等最佳论文奖、DSN时间检验奖、SIGMOD研究亮点奖等。
                            </p>
                            <p class="custom-title">
                                Topic：模型原生操作系统：机遇、挑战与展望
                            </p>
                        </div>
                    </div>
                    
                    <div class="row speaker-block">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Yudong_Jiang.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <p class="custom-title">
                                蒋宇东, 2014年毕业于复旦大学计算机系硕士学位。他曾在阿里巴巴、字节跳动、腾讯等知名一线互联网公司担任核心技术研发和技术管理职位，长期专注于AI技术的创新与落地，积累了广泛且深厚的专业经验。
                                目前，他任职于哔哩哔哩，负责创作端AI技术团队，具体涵盖端上CV与特效算法、2D/3D数字人、多模态视频理解和视频生成等前沿领域。近期，他尤其专注于AI动画、AI辅助智能创作等应用方向，致力于通过AIGC赋能视频创作，推动视频内容创作的智能化升级。
                            </p>
                            <p class="custom-title">
                                Topic：大模型应用 - 动画视频智能创作 
                            </p>
                        </div>
                    </div>
                    <div class="row speaker-block">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Tiezhen_Wang.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <p class="custom-title">
                                王铁震，Hugging Face 工程师，兼具实干精神与梦想追求，坚信开源是连接全球的纽带，让 AI 的益处普惠大众。他秉持"高手在民间"的理念，渴望激励更多的开源模型从业者成为行业的关键意见领袖，挖掘群体的智慧与潜能，促进社区的成长和影响力的扩大。
                            </p>
                            <p class="custom-title">
                               Topic：Why open source matters
                            </p>
                        </div>
                    </div>
                    <div class="row speaker-block">
                        <div class="col-sm-2 d-flex align-items-center">
                            <!-- 左侧图片 -->
                            <img src="/memx-website/sys_photos/Guohao_Dai.jpg" alt="Your Image" style="max-width: 100%; max-height: 100%;">
                        </div>
                        <div class="col-sm-10 py-4 px-5">
                            <!-- 文本内容 -->
                            <p class="custom-title">
                                戴国浩，上海交通大学副教授。主要研究方向为稀疏计算电路与系统，在相关领域的国际顶级会议和期刊发表论文80余篇，谷歌学术施引两千余次。发表论文曾5次获最佳论文奖（FPGA’25，ASP-DAC’25，DATE’24，ASP-DAC’19，ISEDA’25）和3次获最佳论文奖提名。担任领域内多个国际会议TPC成员和期刊审稿人、Ph.D. Forum at DAC 2024联席主席等职务。曾参与指导学生获ACM 2021 SRC 全球第三，MICRO 2020 SRC全球第一。个人荣获2025麻省理工科技评论“35 岁以下科技创新35人”、2025 MIT TR AI100 青年先锋、2024算力中国·青年先锋人物（全国每年10人）、2022 WAIC 云帆奖、2021 NeurIPS BIGANN竞赛全球冠军等荣誉。
                            </p>
                            <p class="custom-title">
                               Topic：面向人工智能的稀疏计算软硬件协同设计方法
                            </p>
                        </div>
                    </div>
                    
                 
                    



                </div>
                

            </div>
            
        
            
                    

                

                
        </section>
    </div>
</template>
<script>
export default {};

</script>
<style>
.speaker-block {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.custom-title {
    font-size: 1em;
    font-weight: 500;
    color: #122143;
    margin: 1em 0;
    text-align: justify;
    text-indent: 2em; /* 👈 缩进2个字 */
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Arial, sans-serif;
}

th,
td {
    border: 1px solid black;
    padding: 10px;
    text-align: center;
    
    /* 👇 保持和 .custom-title 一致 */
    font-size: 1em;           /* 与 .custom-title 一致 */
    font-weight: 500;         /* 与 .custom-title 一致 */
    color: #122143;           /* 与 .custom-title 一致 */
    background-color: #e8e6e6ed;
}

download {
    margin-left: 5px;
    /* 设置图片与文字之间的距离 */
    width: 16px;
    /* 设置图片的宽度为16px */
    height: 16px;
    /* 设置图片的高度为12px */
}
</style>